import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UrlConstants } from './shared/constants';
import { LoginAuth } from './shared/authentications';

const routes: Routes = [
    //{ path: '', redirectTo: UrlConstants.index.index, pathMatch: 'full' },
    //{ path: 'index', loadChildren: './layout/main/main.layout.module#MainLayoutModule' },	//참조파일 :: 주소
    { path: '', loadChildren: './layout/main/main.layout.module#MainLayoutModule' },
    { path: 'popup', loadChildren: './layout/popup/popup.layout.module#PopupLayoutModule' },
    { path: 'mobile', loadChildren: './layout/mobile/mobile.layout.module#MobileLayoutModule' },
    { path: 'error', loadChildren: './layout/error/error.layout.module#ErrorLayoutModule' },
    { path: 'home', redirectTo: '/', pathMatch: 'full' },
    { path: '**',
        redirectTo: UrlConstants.error.notfound,
        pathMatch: 'full'
    }
];

@NgModule({
    imports: [ RouterModule.forRoot(routes) ],
    exports: [ RouterModule ]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts